import { View } from "react-native";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { AssessmentAction } from "../types/AssessmentAction";
import { Fragment } from "react";

interface Props {
  assessment: SubmittedFormModel;
  actions: AssessmentAction[];
  props?: any;
  renderAction?: (
    action: AssessmentAction,
    assessment: SubmittedFormModel,
  ) => React.ReactNode;
}

export function AssessmentActions({
  assessment,
  actions,
  props,
  renderAction,
}: Props) {
  const visibleActions = actions.filter(
    (action) => !action.condition || action.condition(assessment),
  );

  if (visibleActions.length === 0) {
    return null;
  }

  return (
    <View className="flex-row gap-4 justify-end mt-10">
      {visibleActions.map((action) => (
        <Fragment key={action.id}>
          {renderAction ? (
            renderAction(action, assessment)
          ) : (
            <action.component entry={assessment} {...props} />
          )}
        </Fragment>
      ))}
    </View>
  );
}
